import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { BackdropCircular } from 'components';
import QuotePackages from 'pages/quotes/QuoteItems/QuotePackages/QuotePackages';
import AutomatedQuotesSelectedPackage from './AutomatedQuotesSelectedPackage';


const AutomatedQuotesPackages = ({handleCancel}) => {
  const [selectedPackage, setSelectedPackage] = useState(null);

  const {
    packagesLoading,
    quoteProductsLoading,
    loadingQuoteProductSubscriptionOptions
  } = useSelector((state: IReduxState) => state.quote);

  return (
    <div className="mt-2">
      {selectedPackage ?
        <AutomatedQuotesSelectedPackage
          selectedPackage={selectedPackage}
          setSelectedPackage={setSelectedPackage}
          handleCancel={handleCancel}
        />
        : <QuotePackages setSelectedPackage={setSelectedPackage} />
      }
      <BackdropCircular loading={packagesLoading || loadingQuoteProductSubscriptionOptions || quoteProductsLoading} local />
    </div>
  );
};

export default AutomatedQuotesPackages;
